var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 74,
    viewBox: "0 0 175 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1969 31.2276C20.8911 32.8764 1 51.2276 1 51.2276V73.5H174V26.2276C174 26.2276 160.59 31.89 151.643 31.2276C133.463 29.8816 135.591 3.88336 117.575 1.22759C93.647 -2.29971 93.8029 36.3114 69.6677 38.2276C56.7036 39.2569 50.1325 29.9196 37.1969 31.2276Z",
    fill: "url(#paint0_linear_676_1525)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 51.2276C1 51.2276 20.8911 32.8764 37.1969 31.2276C50.1325 29.9196 56.7036 39.2569 69.6677 38.2276C93.8029 36.3114 93.647 -2.29971 117.575 1.22759C135.591 3.88336 133.463 29.8816 151.643 31.2276C160.59 31.89 174 26.2276 174 26.2276",
    stroke: "#F3A53F",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_1525",
    x1: 87.5,
    y1: 1,
    x2: 87.5,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DEBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBEBD6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveOrange);
export default __webpack_public_path__ + "static/media/wave_orange.7c6ba1af61f62858c6c5b2a8c4a8d157.svg";
export { ForwardRef as ReactComponent };